import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { operationalFunction, getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';
import { message } from 'antd';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

//打开Report界面
// 报表选择 Workflow Status Preset 后，把预设内容同步到 WorkflowStatusIds 多选框。
export function workflowStatusPresetOnChange({ parameter, pageComponent, uie } = {}) {
  const reportUieList = pageComponent.state.report?.ReportConfig?.parameters?.uieList || [];
  const hasWorkflowStatusTarget = reportUieList
    .some(reportUie => reportUie.source === 'WorkflowStatusIds');

  // 作为 Report 通用联动，只响应标准 Preset 字段，并要求当前报表配置了目标字段。
  if (uie?.source !== 'WorkflowStatusPresetId' || !hasWorkflowStatusTarget) {
    return;
  }

  const form = pageComponent.formRef.current;
  const workflowStatusPresetId = Number(parameter || 0);

  // 清空 Preset 时同步清空状态选择，不发无意义请求。
  if (workflowStatusPresetId === 0) {
    pageComponent.workflowStatusPresetRequestId =
      (pageComponent.workflowStatusPresetRequestId || 0) + 1;
    form?.setFieldValue('WorkflowStatusIds', []);
    return;
  }

  // 用户快速切换 Preset 时，仅允许最后一次请求更新表单。
  const requestId = (pageComponent.workflowStatusPresetRequestId || 0) + 1;
  pageComponent.workflowStatusPresetRequestId = requestId;

  httpClient
    .get('Admin/WorkflowStatusPreset/' + workflowStatusPresetId)
    .then(({ data }) => {
      if (requestId !== pageComponent.workflowStatusPresetRequestId) {
        return;
      }

      if (data.result) {
        const workflowStatusIds = (data.data.WorkflowStatusPresetContentList || [])
          .map(item => item.WorkflowStatusId);
        form?.setFieldValue('WorkflowStatusIds', workflowStatusIds);
      } else {
        form?.setFieldValue('WorkflowStatusIds', []);
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(error => {
      if (requestId === pageComponent.workflowStatusPresetRequestId) {
        form?.setFieldValue('WorkflowStatusIds', []);
        globalFunction.handleError(error, pageComponent);
      }
    });
}

export function showReportDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Admin/Report/GetReportConfig/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ showModal: true, report: data.data });

        //获取组件数据源
        let componentDataSource = [];
        let parameter = [];
        parameter.push({ key: 'moduleId', value: pageComponent.state.defaultFormData.moduleId });
        pageComponent.state.report.ReportConfig.parameters.uieList.map(async (uie, j) => {
          getUieDataSource({ parameter: parameter, sectionName: 'Report', component: pageComponent, sectionComponent: pageComponent, pageComponent: pageComponent, uie: uie });
        })

      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  addReportShow({ pageComponent, groupName: 'Standard' });
}

export function addReportShow({ pageComponent, groupName } = {}) {
  pageComponent.setState({ reportList: [], selectedRowKeys: [] });
  httpClient
    .get('Admin/Report/GetUnboundList?moduleId=' + pageComponent.state.defaultFormData.moduleId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ showAddReport: true, reportList: data.data });
        setTimeout(() => {
          pageComponent.addReportFormRef.current?.setFieldValue('GroupName', groupName);
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .delete('Admin/Report/Delete?objId=' + parameter.key + '&moduleId=' + pageComponent.state.defaultFormData.moduleId)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        if (data.code === 2) {
          message.error(data.message);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showReportRole: true, currentReport: parameter });
  setTimeout(() => {
    pageComponent.reportRoleFormRef.current.setFieldsValue({ CompanyRoleIdList: parameter.ReportRoleList.map(reportRole => reportRole.CompanyRoleId), GroupName: parameter.GroupName });
  }, config.setTimeoutMilliSecond);
}
